enum BreakpointRangeName {
    Phone = 'Phone',
    TabletPortrait = 'TabletPortrait',
    TabletLandscape = 'TabletLandscape',
    Desktop = 'Desktop',
}

export default BreakpointRangeName;
